import { ResourcesConfig } from '@aws-amplify/core';
import { AppSyncConfiguration } from '../interfaces/appSyncConfiguration';

export const amplifyConfigMapper = (
  params: AppSyncConfiguration
): ResourcesConfig => ({
  API: {
    GraphQL: {
      endpoint: params.aws_appsync_graphqlEndpoint,
      region: params.aws_appsync_region,
      defaultAuthMode: params.aws_appsync_authenticationType.includes(
        'userPool'
      )
        ? 'userPool'
        : 'apiKey'
    }
  }
});
